import React from 'react'

import classNames from 'classnames'

import {
  MapPointContainer,
  MapPointMainCircle,
} from '../../../../common/MapViewer'

export interface IZoneMapPoint {
  id: number // Global database ID
  point_id: number // Local sub_id
  x: string
  y: string
  is_active: boolean
}

interface IZoneMapPointProps {
  x: number
  y: number
  point: IZoneMapPoint
  isInActiveZone: boolean
  isInHoveredZone: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement>, point: IZoneMapPoint) => void
}

export const ZoneMapPoint = ({
  point,
  x,
  y,
  isInActiveZone,
  isInHoveredZone,
  onClick,
}: IZoneMapPointProps) => {
  return (
    <MapPointContainer
      className={`map-point zmp-${point.point_id}`}
      x={x}
      y={y}
      isActive={true}
      onClick={e => {
        if (onClick) {
          onClick(e, point)
        }
      }}
    >
      <MapPointMainCircle
        className={classNames({
          back_pink: isInActiveZone,
          back_blue: isInHoveredZone && !isInActiveZone,
          back_gray_empty: !isInActiveZone && !isInHoveredZone,
        })}
      />
    </MapPointContainer>
  )
}
